import React from "react";
import styles from './ConditionalLink.module.scss';
import {Link} from "react-router-dom";


interface IConditionalLinkProps {
  to?: string;
  children?: any;
}


const ConditionalLink = (props: IConditionalLinkProps) => {
  if (props.to && props.to.length > 0) {
    return (<Link to={props.to} className={styles.container}>
      {props.children}
    </Link>);
  }
  return props.children;
};

ConditionalLink.defaultProps = {};

export default React.memo(ConditionalLink);
